const inputRules = {
  maxTitleLength: 250,
  maxDescriptionLength: 2000
};

export default inputRules;
